import React from 'react';
import ReferenceLink from '@loomstateorg/shared-frontend/components/commercetools-ui/atoms/link';
import useClassNames from '@loomstateorg/shared-frontend/hooks/useClassNames';
import { Reference } from 'types/reference';

export interface Props {
  target: Reference;
  underlined?: boolean;
  withArrow?: boolean;
  className?: string;
  'data-testid'?: string;
}

const Link: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  target,
  underlined = false,
  withArrow = false,
  className = '',
  'data-testid': dataTestId,
}) => {
  const classNames = useClassNames([underlined && 'underline', className]);

  return (
    <ReferenceLink
      link={target}
      className={`flex w-fit items-center gap-12 text-14 font-regular underline-offset-4 md:text-16 ${classNames}`}
      data-testid={dataTestId}
    >
      <span>{children}</span>
      {withArrow && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          className="w-24 stroke-primary-regular"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3" />
        </svg>
      )}
    </ReferenceLink>
  );
};

export default Link;
